<template>
  <v-container fluid grid-list-sm>
    <!-- Column Sorting Table -->
    <v-layout row wrap>
      <v-flex xs12>
        <v-btn color="primary" @click.native="doOpen">Select Columns</v-btn>
      </v-flex>
      <v-flex xs12>
        <v-card>
          <!-- <v-data-table ref="sortOrderTable" :headers="sortHeaders" :items="sortList" item-key="text" :no-data-text="noSelectedColumnsText" hide-default-footer>
            <template v-slot:item="row">
              <td width="50px"><v-icon class="phSortIcon">mdi-cursor-move</v-icon></td>
              <td>{{ row.item.label }}</td>
              <td>{{ row.item.subTotal ? 'Yes' : 'No' }}</td>
              <td>{{ row.item.pageBreak ? 'Yes' : 'No' }}</td>
            </template>
          </v-data-table> -->
          <v-data-table
          :headers="sortHeaders"
          :items="sortList"
          :no-data-text="noSelectedColumnsText"
          hide-default-footer
          item-key="text"
          ref="sortOrderTable"
          >
          <template v-slot:item="row">
            <tr>
              <td width="50px"><v-icon class="phSortIcon">mdi-cursor-move</v-icon></td>
              <td>{{ row.item.label }}</td>
              <td>{{ row.item.subTotal ? 'Yes' : 'No' }}</td>
              <td>{{ row.item.pageBreak ? 'Yes' : 'No' }}</td>
            </tr>
          </template>
          </v-data-table>
        </v-card>
      </v-flex>
      <v-flex xs12>
        <p align="center" v-if="sortList.length > 1">Hold the <v-icon class="phSortIcon">mdi-cursor-move</v-icon> icon to arrange the sequence</p>
      </v-flex>
    </v-layout>
    <!-- Column Selection Table -->
    <v-dialog v-model="showColumnSelection" persistent width="600px">
      <v-card>
        <v-toolbar dense color="grey lighten-3" flat>
          <v-icon>mdi-magnify</v-icon>
          <v-toolbar-title>Select Columns</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn text icon @click="showColumnSelection = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text style="max-height:500px;overflow-y:auto;">
          <v-layout row wrap>
            <v-flex xs12>
              <!-- <v-data-table :headers="selectionHeaders" :items="selectionList" item-key="text" :no-data-text="noColumnsText" hide-default-footer>
                <template v-slot:item="row">
                  <td width="50px">
                    <v-checkbox color="primary" v-model="row.item.selected" />
                  </td>
                  <td>{{ row.item.label }}</td>
                  <td><v-checkbox color="primary" v-model="row.item.subTotal" /></td>
                  <td><v-checkbox color="primary" v-model="row.item.pageBreak" /></td>
                </template>
              </v-data-table> -->
              <v-data-table
              :headers="selectionHeaders"
              :items="selectionList"
              :no-data-text="noColumnsText"
              :server-items-length="totalItems"
              hide-default-footer
              item-key="text"
              >
              <template v-slot:item="row">
                <tr :active="row.selected" :key="row.item.text">
                  <td width="50px">
                    <v-checkbox color="primary" v-model="row.item.selected" />
                  </td>
                  <td>{{ row.item.label }}</td>
                  <td><v-checkbox color="primary" v-model="row.item.subTotal" /></td>
                  <td><v-checkbox color="primary" v-model="row.item.pageBreak" /></td>
                </tr>
              </template>
              </v-data-table>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="primary" @click.native="doSelect">Select</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import Sortable from 'sortablejs'
import clone from 'clone'
export default {
  props: {
    columns: {
      type: Array
    },
    sortedListContainer: {
      type: Object
    }
  },
  data() {
    return {
      showColumnSelection: false,
      noColumnsText: 'No available sort column.',
      noSelectedColumnsText: 'No sort column selected.',
      selectionList: [],
      selectionHeaders: [
        { text: '', value: 'selected', sortable: false },
        { text: 'Sort Order', value: 'label', sortable: false },
        { text: 'Sub Total', value: 'subTotal', sortable: false },
        { text: 'Page Break', value: 'pageBreak', sortable: false }
      ],
      sortList: [],
      sortHeaders: [
        { text: '', value: 'sort', sortable: false },
        { text: 'Sort Order', value: 'label', sortable: false },
        { text: 'Sub Total', value: 'subTotal', sortable: false },
        { text: 'Page Break', value: 'pageBreak', sortable: false }
      ],
      totalItems: 0
    }
  },
  methods: {
    doOpen() {
      if (this.selectionList.length === 0) {
        this.selectionList = []
        if (this.columns) {
          for (var column of this.columns) {
            let columnObj = {
              label: column.label,
              value: column.value,
              selected: false,
              subTotal: false,
              pageBreak: false,
              index: 0
            }
            this.selectionList.push(columnObj)
            this.totalItems = this.selectionList.length
          }
        }
      }
      this.showColumnSelection = true
    },
    doSelect() {
      this.sortList = []
      var count = 0
      for (var column1 of this.selectionList) {
        if (column1.selected) {
          count++
        }
      }
      if (count > 6) {
        this.$toast.error('Please select no more than 6 columns.')
        return
      }
      let cDescList = []
      for (var column of this.selectionList) {
        var columnObj = {
          label: column.label,
          value: column.value,
          subTotal: column.subTotal,
          pageBreak: column.pageBreak,
          index: column.index
        }
        if (column.selected) {
          this.sortList.push(columnObj)
        } else {
          cDescList.push(columnObj)
        }
      }
      this.sortedListContainer.cDescList = cDescList

      var sortOrderHtml = this.$refs['sortOrderTable'].$el.firstElementChild.firstElementChild.tBodies[0]
      for (let r = 0; r < sortOrderHtml.rows.length; r++) {
        const row = sortOrderHtml.rows[r]
        const cell = row.cells[1]
        if (cell !== undefined) {
          const value = cell.innerText
          this.sortList.forEach(item => {
            if (item.label === value) {
              item.index = r
            }
          })
        }
      }
      this.sortedListContainer.sortedList = clone(this.sortList)
      Sortable.create(sortOrderHtml, {
        group: 'sortOrderTable', // group of data
        sort: true, // default allow to sort the table lst
        swapThreshold: 0.65, // the threshold position to swap the element
        delay: 1000, // time in milliseconds to define when the sorting should start
        delayOnTouchOnly: true, // only delay if user is us ing touch
        handle: '.phSortIcon', // to make this class to handle the sort
        animation: 150, // animation
        onEnd: ({ newIndex, oldIndex }) => {
          var sortedList = this.sortedListContainer.sortedList
          var target = sortedList[oldIndex]
          sortedList.splice(oldIndex, 1)
          var newList = []
          for (var i = 0; i < sortedList.length; i++) {
            if (i === newIndex) {
              newList.push(target)
            }
            newList.push(sortedList[i])
          }
          if (sortedList.length === newIndex) {
            newList.push(target)
          }
          this.sortedListContainer.sortedList = newList
        }
      })
      this.showColumnSelection = false
    },
    getLabels() {
      let sortOrderHtml = this.$refs['sortOrderTable'].$el.firstElementChild.firstElementChild.tBodies[0]
      for (let r = 0; r < sortOrderHtml.rows.length; r++) {
        const row = sortOrderHtml.rows[r]
        const cell = row.cells[1]
        if (cell !== undefined) {
          const value = cell.innerText
          this.sortList.forEach(item => {
            if (item.label === value) {
              item.index = r
            }
          })
        }
      }
      return this.sortList
    }
  },
  watch: {
  }
}
</script>
